export default __webpack_public_path__ + "static/media/bg_light.05fa1505.jpg";